// noinspection JSUnusedGlobalSymbols

import Page from "../Page";
import ImageAttachment from "./ImageAttachment";
import Api from "../Api";
import HttpClient from "../HttpClient";
import CreatePayload from "./CreatePayload";
import GetListQuery from "./GetListQuery";

/**
 * Image attachment API
 * @author Kacper Faber
 * @since 0.2.0
 */
class ImageAttachmentApi {
    /**
     * Get image attachments
     * @author Kacper Faber
     * @since 0.2.0
     */
    static getList(query: GetListQuery): Promise<Page<ImageAttachment>> {
        const url = Api.getUrl('/api/image-attachment/');
        return HttpClient.get<Page<ImageAttachment>>(url, { ...query });
    }

    /**
     * Create new ImageAttachment
     * @author Kacper Faber
     * @since 0.2.0
     */
    static create(payload: CreatePayload): Promise<ImageAttachment> {
        const url = Api.getUrl('/api/image-attachment/');
        return HttpClient.postFormData(url, {}, { ...payload });
    }
}

export default ImageAttachmentApi;